export const BinLevelList = [
  { value: 1, label: '1 szint' },
  { value: 2, label: '2 szint' },
  { value: 3, label: '3 szint' },
  { value: 4, label: '4 szint' },
  { value: 5, label: '5 szint' },
];

export const BinLevelMode = [
  { value: 'numeric', label: 'Szám' },
  { value: 'alpha', label: 'Karakter' },
];
